import { graphClient } from "../graph-client";
import {
  CREATE_AGENCY_SALE_DETAIL,
  GET_AGENCIES_SALES_DETAILS,
  GET_AGENCIES_SALES_DETAILS_EXPORT,
  GET_AGENCIES_SALES_DETAILS_SUMMARY,
  GET_AGENCIES_SALES_DETAILS_TOTAL,
  GET_AGENCY_SELLER_STATEMENT,
  GET_AGENCY_SELLER_STATEMENT_EXPORT,
  REVERSE_AGENCY_SALE_DETAIL,
} from "./gql";
import { Create, Export, GetList, Reverse, Statement, StatementExport, Summary, Total } from "./types";

export class AgencySaleDetail {
  async create(params: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_AGENCY_SALE_DETAIL,
      {
        ...params,
      }
    );

    return request?.createAgencySaleDetail;
  }

  async getList(params: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_AGENCIES_SALES_DETAILS,
      { ...params }
    );

    return request?.getAgenciesSalesDetails;
  }

  async reverse(params: Reverse.Input) {
    const request = await graphClient.request<Reverse.Output>(
      REVERSE_AGENCY_SALE_DETAIL,
      { ...params }
    );

    return request?.reverseAgencySaleDetail;
  }

  async getTotal(params: Total.Input) {
    const request = await graphClient.request<Total.Output>(
      GET_AGENCIES_SALES_DETAILS_TOTAL,
      { ...params }
    );

    return request?.getAgenciesSalesDetailsTotal;
  }

  async getSummary(params: Summary.Input) {
    const request = await graphClient.request<Summary.Output>(
      GET_AGENCIES_SALES_DETAILS_SUMMARY,
      { ...params }
    );

    return request?.getAgenciesSalesDetailsSummary;
  }

  async getExport(params: Export.Input) {
    const request = await graphClient.request<Export.Output>(
      GET_AGENCIES_SALES_DETAILS_EXPORT,
      { ...params }
    );

    return request?.getAgenciesSalesDetailsExport;
  }

  async getStatement(params: Statement.Input) {
    const request = await graphClient.request<Statement.Output>(
      GET_AGENCY_SELLER_STATEMENT,
      { ...params }
    );
    return request?.getAgencySellerStatement;
  }

  async getStatementExport(params: StatementExport.Input) {
    const request = await graphClient.request<StatementExport.Output>(
      GET_AGENCY_SELLER_STATEMENT_EXPORT,
      { ...params }
    );
    return request?.getAgencySellerStatementExport;
  }
}

export const agencySaleDetail = new AgencySaleDetail();
